import axios from "axios";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class HotelService {

static gethotellist(params = {}) {
  const api = `${API_BASE_URL}${API_PATHS.gethotels}`;
  return axios
    .get(api, { params })   
    .then((response) => response.data) 
    .catch((error) => {
      console.error("Error in gethotellist:", error);
      throw error;
    });
}


  static getplaceslist(item) {
  
      let api = '';
      if(item?.id){
        api= `${API_BASE_URL}${API_PATHS.getplaces}?id=${item?.id}`
     }
     else
      if(item?.visibility){
        api= `${API_BASE_URL}${API_PATHS.getplaces}?visibility=${item?.visibility}`
     }
     else 
     
      api = `${API_BASE_URL}${API_PATHS.getplaces}?limit=${item?.limit}`;
      
       return axios
        .get(api)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }

static getsearchsuggestion(item) {
  if (!item?.search || item.search.trim().length < 2) {
    return Promise.resolve({ suggestions: [] });
  }

  const api = `${API_BASE_URL}${API_PATHS.searchsuggestion}?q=${encodeURIComponent(
    item.search.trim()
  )}`;

  return axios
    .get(api)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
}




      static getPropertyType() {
  
      let api = '';
     
     
      api = `${API_BASE_URL}${API_PATHS.propertytype}`;
      
       return axios
        .get(api)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }


  static gethotelDetails(item) {
  
    let api = '';
    
   
    api = `${API_BASE_URL}${API_PATHS.gethotelDetails}?hotelId=${item?.id}`;
    
     return axios
      .get(api)
      .then((response) => {
        if (response.data) {
        }
        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }

  

  
}

export default HotelService;